<template>
    <div class="loader-container">
      <div class="spinner"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'loader'
  };
  </script>
  
  <style scoped lang=scss>
  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8);
    .spinner {
        border: 5px solid;
        border-color: #ecf0f1;
        border-top: 5px solid;
        border-top-color: #34495e;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        -webkit-animation: spin 1s linear infinite;
        animation: spin 0.8s linear infinite;
        position: absolute;
        box-shadow: 0 0 1px 2px #ecf0f1;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
  }
  </style>
  